import React, { createContext, useState, useEffect, useContext, useMemo } from 'react';
import { supabase } from '../webSupabaseClient'; 
import { toast } from 'react-toastify';

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // 1. İlk oturumu al ve durumu ayarla
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setLoading(false);
    });

    // 2. Kimlik doğrulama durumundaki tüm değişiklikleri dinle
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      // Herhangi bir auth olayında (SIGNED_IN, SIGNED_OUT, TOKEN_REFRESHED, vb.)
      // session durumunu en güncel haliyle ayarla.
      setSession(session);
    });

    // 3. Component unmount olduğunda dinleyiciyi temizle
    return () => {
      subscription?.unsubscribe();
    };
  }, []);

  const value = useMemo(() => {
    return {
      session,
      user: session?.user ?? null,
      isAdmin: session?.user?.app_metadata?.roles?.includes('admin') ?? false,
      token: session?.access_token ?? null,
      supabase, // Supabase client'ı doğrudan export ediyoruz
      loading,
      login: (email, password) => supabase.auth.signInWithPassword({ email, password }),
      signInWithGoogle: () => supabase.auth.signInWithOAuth({
        provider: 'google',
        options: {
          redirectTo: window.location.origin
        }
      }),
      register: (email, password, options) => supabase.auth.signUp({ email, password, options }),
      logout: () => supabase.auth.signOut(),
    };
  }, [session, loading]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};